<template>
  <div class="overflow-y-hidden rounded-xl h-full flex flex-col w-full">
    <Transition>
      <!-- PAGE -->
      <div
        class="h-full w-full pointer-events-auto overflow-y-auto rounded-xl relative overflow-x-hidden flex flex-col-reverse"
        :style="[backgroundStyle]"
      >
        <Tabs v-if="loggedIn" />
        <!-- INNER VIEW -->
        <slot></slot>
        <!-- TABS / NAV BAR -->
      </div>
    </Transition>
  </div>
</template>

<script setup lang="ts">
import Tabs from './Tabs.vue';
import { useAdminStore } from '@getmayday/vue-modules';

const adminStore = useAdminStore();
const { loggedIn } = storeToRefs(adminStore);

const props = defineProps({
  backgroundColor: {
    type: String,
    default: null,
  },
  fullscreen: {
    type: Boolean,
    default: false,
  },
});

const configStore = useConfigStore();
const { integrationPrimaryColor } = storeToRefs(configStore);

const backgroundStyle = computed(() => {
  return `
  transition: background 750ms ease, transform 750ms ease;
  background: linear-gradient(to bottom, ${
    props.backgroundColor || integrationPrimaryColor.value
  }, #ffffff);
  `;
});

// THIS PART IS NEEDED BECAUSE OF THE ROUTER TRANSITION
const route = useRoute();
const disabledTransition = ref(false);
watch(
  () => route.fullPath,
  () => {
    disabledTransition.value = true;
    setTimeout(() => {
      disabledTransition.value = false;
    }, 500);
  },
);
</script>
